module.exports = __webpack_public_path__ + "static/media/calendar.fcaefeac.svg";